import { automationCapabilityIdRenderer } from 'components/FieldRenderers/Renderers/automation'
import { automationCapabilityId } from 'configuration/fieldCreators/automation'
import { brandId } from 'configuration/fieldCreators/brand'
import { campaignId } from 'configuration/fieldCreators/campaign'
import { countryCode, region } from 'configuration/fieldCreators/changelog'
import { portfolioId } from 'configuration/fieldCreators/portfolio'
import { userId } from 'configuration/fieldCreators/user'

export const SPECIAL_CHANGELOG_GROUP_BY_COLUMNS = [
    automationCapabilityId({
        dataIndex: ['automation_capability_id'],
        renderOptions: {
            render: (cellRenderProps) =>
                automationCapabilityIdRenderer<any>({
                    cellRenderProps,
                }),
        },
    }),
    campaignId({
        dataIndex: ['campaign', 'id'],
    }),
    portfolioId({
        dataIndex: ['portfolio', 'id'],
    }),
    brandId({
        dataIndex: ['profile', 'id'],
    }),
    region({
        dataIndex: ['region'],
    }),
    countryCode({
        dataIndex: ['country_code'],
    }),
    userId({ dataIndex: ['user_id'] }),
]
